module.exports = __webpack_public_path__ + "components/rewards/app/static/logo-f44ef89f638789f9e2e17b3c1c3b04f1.webp";